import React from 'react';
import {
  Box,
  Button,
  Card,
  CardBody,
  ExternalLinkIcon,
  InfoIcon,
  Link,
  Text,
} from '@razorpay/blade/components';

import { routePaths } from 'components/Routes/data';
import { Wrapper } from './styles';
import { resetIsSkippedCountConsentGranted } from '../contexts/runPayrollSlice';
import { useDispatch } from 'react-redux';

export default function ExecutionButton({
  skippedEmployees,
  pastPayrollExecutionHelpLink,
  isTdsFilingConfigRequired,
  setIsOpen,
  payrollMonth,
}: {
  skippedEmployees: number;
  pastPayrollExecutionHelpLink: string;
  isTdsFilingConfigRequired: boolean;
  setIsOpen: (isOpen: boolean) => void;
  payrollMonth: string;
}) {
  const dispatch = useDispatch();

  return (
    <Wrapper>
      <Card padding="spacing.7" width="100%">
        <CardBody>
          <Box display="flex" alignItems="center" marginBottom="spacing.3">
            <InfoIcon color="interactive.icon.information.normal" size="medium" />
            <Text
              marginLeft="spacing.2"
              size="medium"
              weight="medium"
              color="interactive.text.information.normal">
              {skippedEmployees} pending payrolls
            </Text>
          </Box>
          <Text color="surface.text.gray.muted" marginTop="spacing.3">
            {skippedEmployees} pending payroll in this financial year. Execute past payroll if
            missed.{' '}
            <Link href={pastPayrollExecutionHelpLink} icon={ExternalLinkIcon} iconPosition="right">
              Learn more
            </Link>
          </Text>
          <Box marginTop="spacing.6">
            <Button
              isFullWidth
              variant="primary"
              marginBottom="spacing.5"
              onClick={() => {
                dispatch(resetIsSkippedCountConsentGranted());
                setIsOpen(true);
              }}
              isDisabled={isTdsFilingConfigRequired}>
              Request Execution
            </Button>
            <Button
              isFullWidth
              href={`${routePaths.customReport.root}?type=15&payrollMonth=${payrollMonth}`}
              target="_blank"
              variant="tertiary"
              icon={ExternalLinkIcon}
              iconPosition="right"
              testID="view-pending-report-button">
              View pending report
            </Button>
          </Box>
        </CardBody>
      </Card>
    </Wrapper>
  );
}
